
import { Vue, Component, Prop } from 'vue-property-decorator'
import DashboardButton from '~/components/common/buttons/DashboardButton.vue'
import LineLoader from '~/components/common/loader/LineLoader.vue'

@Component({
  name: 'FooterBasic',
  components: {
    DashboardButton,
    LineLoader
  }
})
export default class FooterBasic extends Vue {
  @Prop({ type: String, default: 'Close' }) readonly closeButtonText: string
  @Prop({ type: String, default: '' }) readonly closeButtonClass: string
  @Prop({ type: Boolean, default: false }) readonly loading: boolean
}
